import type { IEnglishIqV2StoredFlow } from '../english-iq-v2-stored-flow';
import { ENGLISH_IQ_V2_STORAGE_KEY } from './english-iq-v2-storage-key';

export function persistEnglishIqV2StoredFlow(flow: IEnglishIqV2StoredFlow): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(ENGLISH_IQ_V2_STORAGE_KEY, JSON.stringify(flow));
}
